<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <addHeader
          :title="$t('Add Customer')"
          :description="$t('From here you can create new customer')"
          v-if="$route.name == 'customersCreate'"
        />
        <addHeader
          :title="$t('Edit customer')"
          :description="$t('From here you can edit customer')"
          v-if="$route.name == 'customersEdit'"
        />
        <div class="mb-4 row">
          <dvider
            :title="$t('Basic Information')"
            :description="$t('Customer basic information')"
            noLine="true"
          />

          <formInput
            :title="$t('Customer Name')"
            :checkError="'nameError'"
            v-model="item.name"
            maxlength="255"
            :hasError="errors.name"
            :error="$t('Field Required Error')"
          />
          <formInput :title="$t('Customer code')" v-model="item.tax_number" maxlength="255" />

          <checkInput :title="$t('Customer case')" :value="item.stat" v-model="item.stat" />
          <!-- need-review -->
          <searchGroupInput
            :type="'sectionsAccount'"
            v-model="item.sections_account_id"
            :values="$database.sectionsAccounts"
            :model="'sections_account'"
            :inputs="[{ show: 'name' }]"
          />

          <dvider
            :title="$t('Account Settings')"
            :description="$t('From here you can control settings accounts')"
          />

          <selectInput
            :title="$t('Balance type')"
            v-model="item.balance_type"
            :disabled="$route.name == 'customersEdit'"
            :values="[
              { value: 0, name: $t('Cumulative') },
              { value: 1, name: $t('Creditor and Debitor') }
            ]"
          />

          <monyInput
            :title="$t('Initial balance')"
            v-model="item.balance"
            :disabled="$route.name == 'customersEdit' || item.balance_type == 1"
            :checkError="'nameError'"
            :hasError="errors.balance"
            :error="$t('Field Required Error')"
          />

          <monyInput
            v-if="item.balance_type == 1"
            :title="$t('Debit')"
            v-model="item.debit"
            :disabled="$route.name == 'customersEdit'"
            :checkError="'nameError'"
            :hasError="errors.debit"
            :error="$t('Field Required Error')"
          />

          <monyInput
            v-if="item.balance_type == 1"
            :title="$t('Creditor')"
            v-model="item.creditor"
            :disabled="$route.name == 'customersEdit'"
            :checkError="'nameError'"
            :hasError="errors.creditor"
            :error="$t('Field Required Error')"
          />

          <connectionInput
            :title="$t('Price list')"
            :group="$t('Price lists')"
            v-model="item.priceList_id"
            :values="$database.priceLists"
          />

          <formInput :title="$t('Debit limit')" v-model="item.max_balance" maxlength="255" />

          <dvider
            :title="$t('Billing address')"
            :description="$t('The title Of billing and the invoice is recorded')"
          />
          <formInput :title="$t('Title')" v-model="item.address1" maxlength="255" />
          <formInput :title="$t('Itinerary')" v-model="item.address2" maxlength="255" />
          <formInput :title="$t('Governorate')" v-model="item.entity" maxlength="255" />
          <formInput :title="$t('City')" v-model="item.city" maxlength="255" />
          <formInput :title="$t('Postal code')" v-model="item.zip" maxlength="255" />
          <formInput :title="$t('State')" v-model="item.country" maxlength="255" />

          <dvider
            :title="$t('Contact information')"
            :description="$t('Customer contact information')"
          />
          <iconInput
            :type="'text'"
            :title="$t('Mobile number')"
            :icon="'phone'"
            v-model="item.mobile"
          />
          <iconInput
            :type="'text'"
            :title="$t('Another number')"
            :icon="'phone'"
            v-model="item.mobile2"
          />
          <iconInput :type="'text'" :title="$t('Email')" :icon="'at'" v-model="item.email" />

          <!-- Divider -->
          <hr class="mt-5 mb-5 col-12" />
          <!-- Buttons -->
          <a
            @click="saveItem"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'customersCreate' && !$parent.stopEdit"
          >
            {{ $t('Add customer') }}
          </a>
          <a
            @click="saveItem"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'customersEdit' && !$parent.stopEdit"
          >
            {{ $t('Edit customer') }}
          </a>
          <loading v-if="$parent.stopEdit" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

import formInput from '@/elements/add/form/formInput.vue'
import fileInput from '@/elements/add/form/fileInput.vue'
import selectInput from '@/elements/add/form/selectInput.vue'
import monyInput from '@/elements/add/form/monyInput.vue'
import checkInput from '@/elements/add/form/checkInput.vue'
import iconInput from '@/elements/add/form/iconInput.vue'
import dvider from '@/elements/add/dvider.vue'
import addHeader from '@/elements/add/header.vue'
import loading from '@/elements/add/loading.vue'
import connectionInput from '@/elements/add/form/connectionInput.vue'
import searchGroupInput from '@/elements/add/form/searchGroupInput.vue'
import subFileInput from '@/elements/add/form/subFileInput.vue'

export default {
  data() {
    return {
      path: '/customers',
      item: {
        stat: 1,
        balance_type: 1,
        sections_account: {}
      },
      errors: {
        name: false,
        balance: false
      }
    }
  },
  methods: {
    saveItem() {
      let error = 0
      if (!this.item.name) {
        error = 1
        this.errors.name = true
      }
      if (this.item.balance && this.item.balance.length > 11) {
        error = 1
        this.errors.balance = true
      }
      if (error === 0) {
        if (this.$route.name === 'customersCreate') {
          this.$parent.alertText = this.$t('Customer successfully added')
          this.$parent.alertType = 'success'
          this.$addToLocalDatabase(this.item, 'customers')
          this.$router.go(-1)
        } else if (this.$route.name === 'customersEdit') {
          this.item._method = 'PUT'
          this.$parent.stopEdit = true
          axios
            .post(this.$linkGenerator(this.path + '/' + this.item.id), this.item)
            .then((response) => {
              if (response.data === 'repeated') {
                this.$parent.alertText = this.$t('Duplicate customer code')
                this.$parent.alertType = 'danger'
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                })
                this.$parent.stopEdit = false
                this.loading = false
              } else {
                this.$parent.alertText = this.$t('Customer modified successfully')
                this.$parent.alertType = 'success'
                this.$router.go(-1)
                this.$parent.stopEdit = false
                this.loading = false
              }
            })
        }
      } else {
        this.$parent.alertText = this.$t('please check input')
        this.$parent.alertType = 'danger'
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    getItem() {
      const item = this.$database.customers.find((el) => el.id == this.$route.params.id)
      if (item) this.item = item
      this.$parent.stopEdit = false
    },
    calculateBalance() {
      this.item.balance = parseFloat(this.item.creditor || 0) - parseFloat(this.item.debit || 0)
      if (this.item.balance_type === 1) {
        this.item.balance = -this.item.balance
      }
    }
  },
  watch: {
    'item.name': function (val) {
      const customer = this.$database.customers.find(
        (el) => el.name === val && el.id !== this.item.id
      )
      if (customer) {
        this.$parent.alertText = this.$t('Duplicate customer name')
        this.$parent.alertType = 'danger'
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    'item.tax_number': function (val) {
      const customer = this.$database.customers.find(
        (el) => el.tax_number === val && el.id !== this.item.id
      )
      if (customer && val) {
        this.$parent.alertText = this.$t('Duplicate customer code')
        this.$parent.alertType = 'danger'
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    'item.debit': function () {
      this.calculateBalance()
    },
    'item.creditor': function () {
      this.calculateBalance()
    },
    'item.balance_type': function () {
      this.calculateBalance()
    }
  },
  mounted() {
    this.$updateDatabase(['customers'])
    if (this.$route.name === 'customersEdit') {
      this.$parent.stopEdit = true
      this.getItem()
    }

    window.addEventListener('keydown', (e) => {
      if (e.key === 'F1' || e.key === 'Meta') {
        e.preventDefault()
        this.saveItem()
      }
    })
  },
  components: {
    formInput,
    fileInput,
    dvider,
    addHeader,
    monyInput,
    checkInput,
    iconInput,
    selectInput,
    loading,
    connectionInput,
    searchGroupInput,
    subFileInput
  }
}
</script>
